module.exports = __webpack_public_path__ + "img/kc.7a59c8e8.png";